import React, { useState } from "react";
import { Image, Col, Modal, Stack } from "react-bootstrap";
import PizzaIcon from "../../assets/images/pizza.png";
import "../../assets/styles/Login.css";
import Register from "./Register";
import Login from "./Login";

const LoginModal = ({ showLoginModal, setShowLoginModal }) => {
  const [register, setRegister] = useState(false);
  const handleClose = () => setShowLoginModal(false);

  return (
    <Modal
      show={showLoginModal}
      onHide={handleClose}
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Stack direction="horizontal">
        <Col className="d-none d-sm-block">
          <Image
            src={PizzaIcon}
            style={{ width: "50%" }}
            className="m-3 mx-auto d-block"
          />
        </Col>
        <div className="vr d-none d-sm-block"></div>
        <Col className="">
          {register ? (
            <Register
              setShowLoginModal={setShowLoginModal}
              setRegister={setRegister}
            />
          ) : (
            <Login
              setShowLoginModal={setShowLoginModal}
              setRegister={setRegister}
            />
          )}
        </Col>
      </Stack>
    </Modal>
  );
};

export default LoginModal;
